import { Entrypoints } from 'core/app/entrypoints';

import { PCCache } from 'data/PCCache';

import { PilotJobOrder } from 'data/models/PilotJobOrder';
import { PilotJobOrderRelevance, PilotJobOrderRelevanceOptions } from 'data/models/PilotJobOrderRelevance';

import { LogUpdater, LogUpdaterParams } from 'portcall/eventlog/logupdater';

const LOG_REFRESH_SECONDS = 20,
    LOG_REFRESH_BACKWARDS_MINS = 10;

export interface PilotJobOrderLogUpdaterParams {
    pjo : PilotJobOrder;
}

export type PilotJobOrderLogUpdater = ReturnType<typeof PilotJobOrderLogUpdater>;
export function PilotJobOrderLogUpdater(
    entrypoints : Entrypoints,
    data : PCCache,
    logUpdaterModel : (params : LogUpdaterParams<PilotJobOrderRelevance, PilotJobOrderRelevanceOptions>) => LogUpdater,
    { pjo } : PilotJobOrderLogUpdaterParams
) {
    return logUpdaterModel({
        collection: data.PilotJobOrderRelevances,
        url: ({ NeedSince }) => entrypoints.PilotJobOrderLog({ Id: pjo.Id(), NeedSince }),
        refreshSeconds: LOG_REFRESH_SECONDS,
        refreshBackwardsMins: LOG_REFRESH_BACKWARDS_MINS
    });
}



// WEBPACK FOOTER //
// ./apps/pilots/pilotjoborderlog/logupdater.ts